import { CHAT_CONTENT_TYPES } from "../types";
import "amazon-connect-streams";

/**
 * Checks if an event is a participant event (join/leave).
 */
export function isParticipantEvent(contentType?: string): boolean {
    return contentType === CHAT_CONTENT_TYPES.PARTICIPANT_JOINED || contentType === CHAT_CONTENT_TYPES.PARTICIPANT_LEFT;
}

/**
 * Extracts participant join time from a chat event if the participant ID matches.
 */
export function getParticipantJoinTime(item: connect.ChatEventData, participantId: string): Date | undefined {
    if (
        item.ContentType === CHAT_CONTENT_TYPES.PARTICIPANT_JOINED &&
        item.ParticipantId === participantId &&
        item.AbsoluteTime
    ) {
        return new Date(item.AbsoluteTime);
    }
    return undefined;
}

/**
 * Extracts participant leave time from a chat event if the participant ID matches.
 */
export function getParticipantLeaveTime(item: connect.ChatEventData, participantId: string): Date | undefined {
    if (
        item.ContentType === CHAT_CONTENT_TYPES.PARTICIPANT_LEFT &&
        item.ParticipantId === participantId &&
        item.AbsoluteTime
    ) {
        return new Date(item.AbsoluteTime);
    }
    return undefined;
}
